import React from 'react'
import styled from 'styled-components'

import Loadsmart from 'assets/icons/loadsmart.svg'
import { Cell, Row } from 'components/TableV1'

import { Checkbox } from './styles'
import { LOADSMART } from '../../constants'
import { useSelector } from 'react-redux'
import { carrierInvitesMapSelector } from 'features/carrierInvites/selectors'
import Badge from 'components/Badge'
import type { BadgeVariant } from 'components/Badge'

const Span = styled.span`
  vertical-align: super;
`

interface Props {
  carrier: Carrier
  toggle: () => void
  isInvited: boolean
  disabled?: boolean
  showAcceptanceState: boolean
}

const isLoadsmartCarrier = (carrier: Carrier) => carrier.dot === LOADSMART.dot

const getBadgeVariant = (status: string): BadgeVariant => {
  if (status === 'accepted') {
    return 'success'
  }
  return 'secondary'
}

export default function CarrierRow({
  carrier,
  disabled = false,
  isInvited,
  showAcceptanceState,
  toggle,
}: Props) {
  const carrierInvites = useSelector(carrierInvitesMapSelector)
  const isLoadsmart = isLoadsmartCarrier(carrier)
  const invite = carrierInvites[carrier.id]
  const inviteAcceptanceState = invite ? invite.invite_accepted_state : ''
  return (
    <Row>
      <Cell width={200} data-offset="{'top': -10, 'left': 0}">
        {!disabled && <Checkbox value={isInvited} onToggle={toggle} inline />}
        {isLoadsmart ? (
          <object type="image/svg+xml" data={Loadsmart}>
            {carrier.name}
          </object>
        ) : (
          <Span data-tip={carrier.name}>{carrier.name}</Span>
        )}
      </Cell>
      <Cell
        width={200}
        data-tip={carrier.dot}
        data-offset="{'top': -10, 'left': 0}"
      >
        {carrier.dot}
      </Cell>
      <Cell
        width={250}
        data-tip={carrier.email}
        data-offset="{'top': -10, 'left': 0}"
      >
        {carrier.email}
      </Cell>
      {showAcceptanceState && (
        <Cell width={75}>
          {inviteAcceptanceState && (
            <Badge variant={getBadgeVariant(inviteAcceptanceState)}>
              {inviteAcceptanceState}
            </Badge>
          )}
        </Cell>
      )}
    </Row>
  )
}
